import axios from 'axios';
import { getUserData } from './storageService';

const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/live-policy`
  : 'https://backend-c-0mxm.onrender.com/api/live-policy';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const user = getUserData();
  if (user) {
    config.headers.Authorization = `Bearer ${user.userId || user.token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.response) {
    return { message: error.response.data.message || 'Có lỗi xảy ra', status: error.response.status };
  }
  if (error.request) {
    return { message: 'Không thể kết nối đến server', status: 0 };
  }
  return { message: 'Có lỗi xảy ra', status: 0 };
};

export const getLivePolicy = async (userId) => {
  try {
    const response = await api.get(`/${userId}`);
    return { success: true, data: response.data.data, isDefault: response.data.isDefault };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const getAllLivePolicies = async () => {
  try {
    const response = await api.get('/');
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const getPolicyDefaults = async (template) => {
  try {
    const response = await api.get(`/defaults/${template}`);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const updateLivePolicy = async (userId, policyData) => {
  try {
    const response = await api.put(`/${userId}`, policyData);
    return { success: true, data: response.data.data, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const applyPolicyTemplate = async (userId, template) => {
  try {
    const response = await api.post(`/${userId}/apply-template`, { template });
    return { success: true, data: response.data.data, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const deleteLivePolicy = async (userId) => {
  try {
    const response = await api.delete(`/${userId}`);
    return { success: true, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};
